export const dmConfig = {
  noCUSS: false,
  port: 8091,
  defaultAirportCode: 'HNL', // This is only required in case without CUSS
};
dmConfig.noCUSS = false;
